import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=13546756"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=13546756&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports